/* eslint-disable */

import { nfRoundedDynamic, moneyFmtRoundedDynamic } from "./formatters";

// Formatea valores "previos" del detalle de recaudaciones en enteros redondeados.
export const formatPrevCollectionValue = (value, { useMoney = false } = {}) => {
  if (value == null) return "-";
  return useMoney ? moneyFmtRoundedDynamic.format(value) : nfRoundedDynamic.format(value);
};

